// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/flag.js';

import { paths } from '../generated/flag';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('flag', Original, paths);
